import VideoModal from './videomodal'

export default VideoModal
